const htmlTableNodesToLatexPrinter = (node, printChildren) => {
  var _a, _b, _c, _d;
  if (!node.children) {
    return "";
  }
  const children = printChildren(node.children).join("");
  switch (node.tagName) {
    case "table": {
      const columnCount = ((_d = (_c = (_b = (_a = node.children.find(
        (it) => it.nodeType === "html" && it.tagName === "tbody"
      )) == null ? void 0 : _a.children) == null ? void 0 : _b.find(
        (it) => it.nodeType === "html" && it.tagName === "tr"
      )) == null ? void 0 : _c.children) == null ? void 0 : _d.length) ?? 1;
      return `\\begin{table}[]
\\begin{tabular}{${"l".repeat(columnCount)}}
\\toprule
${children}
\\bottomrule
\\end{tabular}
\\end{table}
`;
    }
    case "thead":
      return handleTHead(node, printChildren);
    case "tbody":
      return handleTBody(node, printChildren);
    default:
      return children;
  }
};
function handleTHead(node, printChildren) {
  var _a, _b;
  const row = (_a = node.children) == null ? void 0 : _a.find(
    (it) => it.nodeType === "html" && it.tagName === "tr"
  );
  const cellsContent = [];
  const cells = ((_b = row == null ? void 0 : row.children) == null ? void 0 : _b.filter(
    (it) => it.nodeType === "html" && (it.tagName === "th" || it.tagName === "td")
  )) ?? [];
  for (const cell of cells) {
    const cellContent = printChildren(cell.children).join("");
    cellsContent.push(`\\textbf{${cellContent}}`);
  }
  return `${cellsContent.join(" & ")}\\tabularnewline
\\midrule
\\endhead
`;
}
function handleTBody(node, printChildren) {
  var _a, _b;
  const rows = ((_a = node.children) == null ? void 0 : _a.filter(
    (it) => it.nodeType === "html" && it.tagName === "tr"
  )) ?? [];
  const formattedRows = [];
  for (const row of rows) {
    const cellsContent = [];
    const cells = ((_b = row == null ? void 0 : row.children) == null ? void 0 : _b.filter(
      (it) => it.nodeType === "html" && (it.tagName === "th" || it.tagName === "td")
    )) ?? [];
    for (const cell of cells) {
      const cellContent = printChildren(cell.children).join("");
      cellsContent.push(cellContent);
    }
    formattedRows.push(cellsContent.join(" & "));
  }
  return `${formattedRows.join("\\tabularnewline\n")}\\tabularnewline`;
}

export { htmlTableNodesToLatexPrinter };
//# sourceMappingURL=html.table.js.map
